import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { NavigateFunction } from "react-router-dom";
import { useAnalyticsStore } from "./AnalyticsStore/analyticsStore";
import { fetchCamerasBySite } from "./AnalyticsStore/analyticsStore";
import { updateSearchParamValues } from "../../utils/updateSearchParamValues";

export const SiteDropDown = ({
  navigate,
  searchParams,
  setSearchParams,
}: {
  navigate: NavigateFunction;
  searchParams: URLSearchParams;
  setSearchParams: (searchParams: URLSearchParams) => void;
}) => {
  const {
    userFilters,
    setUserFilters,
    siteOptions,
    setCameraOptions,
    siteDropDownValue,
    setSiteDropDownValue,
    setCameraDropDownValue,
    loadingSites,
  } = useAnalyticsStore();

  const siteIds = new Map();
  siteOptions.forEach((object: any) => {
    siteIds.set(object.name, object.id);
  });

  return (
    <div key="site_dropdown">
      <Autocomplete
        multiple
        limitTags={1}
        value={
          siteDropDownValue && siteDropDownValue.length > 0
            ? siteDropDownValue
                .map((siteName: string) => {
                  const siteOption = siteOptions.find(
                    (site: any) => site.name === siteName
                  );
                  return siteOption
                    ? { id: siteOption.id, name: siteOption.name }
                    : null;
                })
                .filter((item: any) => item !== null)
            : []
        }
        disablePortal
        options={
          siteOptions && siteOptions.length > 0
            ? siteOptions.map((object: any) => ({
                id: object.id,
                name: object.name,
              }))
            : []
        }
        getOptionLabel={(option) => {
          if (!option || typeof option === "string") {
            return option || "";
          }
          return option.name || "";
        }}
        isOptionEqualToValue={(option, value) => {
          if (!option || !value) return false;
          return option.id === value.id;
        }}
        loading={loadingSites}
        onChange={(event, value: any[]) => {
          if (value && value.length > 0) {
            const siteIdsArray: string[] = [];
            const siteValuesArray: string[] = [];
            value.forEach((element: any) => {
              if (element && element.id && element.name) {
                siteIdsArray.push(element.id);
                siteValuesArray.push(element.name);
              }
            });

            if (localStorage.filtersSavedClicked === "true") {
              localStorage.setItem(
                "siteDropDownValues",
                JSON.stringify(siteValuesArray)
              );
              localStorage.setItem(
                "savedAnalyticsFilters",
                JSON.stringify({
                  parent_group: userFilters.parent_group,
                  site: siteIdsArray,
                  camera: [],
                  start_date: userFilters.start_date,
                  end_date: userFilters.end_date,
                })
              );
            }

            setSiteDropDownValue(siteValuesArray);
            localStorage.setItem(
              "siteDropDownValueAnalytics",
              JSON.stringify(siteValuesArray)
            );
            setCameraDropDownValue([]);
            localStorage.setItem("cameraDropDownValues", "[]");

            fetchCamerasBySite(siteIdsArray, navigate);

            setUserFilters((previousState) => {
              return {
                ...previousState,
                site: siteIdsArray,
                camera: [],
              };
            });
            updateSearchParamValues(
              {
                ...userFilters,
                site: siteIdsArray,
                camera: [],
              },
              searchParams,
              setSearchParams,
              ""
            );
          } else {
            setSiteDropDownValue([]);
            localStorage.setItem(
              "siteDropDownValueAnalytics",
              JSON.stringify([])
            );
            setCameraDropDownValue([]);
            localStorage.setItem(
              "cameraDropDownValueAnalytics",
              JSON.stringify([])
            );
            setCameraOptions([]);

            setUserFilters((previousState) => {
              return {
                ...previousState,
                site: [],
                camera: [],
              };
            });
            updateSearchParamValues(
              {
                ...userFilters,
                site: [],
                camera: [],
              },
              searchParams,
              setSearchParams,
              ""
            );

            if (localStorage.filtersSavedClicked === "true") {
              localStorage.setItem("siteDropDownValues", JSON.stringify([]));
              localStorage.setItem("cameraDropDownValues", JSON.stringify([]));
              localStorage.setItem(
                "savedAnalyticsFilters",
                JSON.stringify({
                  parent_group: userFilters.parent_group,
                  site: [],
                  camera: [],
                  start_date: userFilters.start_date,
                  end_date: userFilters.end_date,
                })
              );
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Sites"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSites ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            sx={{ width: 285 }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option?.id || Math.random()}>
            {option?.name || ""}
          </li>
        )}
      />
    </div>
  );
};
